module.exports = __webpack_public_path__ + "fonts/SourceSansPro-LightItalic.54e87ded.ttf";